import React, { useEffect } from 'react';
import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { ErrorToast, SuccessToast, WarningToast } from 'components/Toast';
import { STRINGS } from 'config';

const showSuccessToast = (message = 'Success') => toast.success(<SuccessToast message={message} />, { icon: false, autoClose: 12000 });
const showErrorToast = (message = 'There was an error. Please try again.') => toast.error(<ErrorToast message={message} />, { icon: false, autoClose: 12000 });
const showWarningToast = (message = 'Warning') => toast.warning(<WarningToast message={message} />, { icon: false, autoClose: 12000 });

export const injectTranscript = (dispatch: React.Dispatch<unknown>) => (transcript: string): void => {
  transcript.split('\n').forEach(line => {
    if (line.trim()) {
      dispatch({ type: STRINGS.REDUCERS.TRANSCRIPTION.ADD_TRANSCRIPTION, payload: line });
    }
  });
};

export const injectTemplates = (dispatch: React.Dispatch<unknown>) => (templates: []): void => {
  dispatch({ type: STRINGS.REDUCERS.TEMPLATES_REDUCER.GET_TEMPLATES_SUCCESS, payload: templates });
};

const testingIntegrationFunctions = () => ({
  showSuccessToast: (message: string) => showSuccessToast(message),
  showErrorToast: (message: string) => showErrorToast(message),
  showWarningToast: (message: string) => showWarningToast(message),
  injectTranscript: (text: string) => injectTranscript(window.appDispatch)(text),
  injectTemplates: (templates: []) => injectTemplates(window.appDispatch)(templates),
});

export const DevTestIntegrationInit = () => {
  useEffect(() => {
    if (STRINGS.ENVIRONMENT.IS_DEV_OR_TEST_ENV) {
      window.devTestFrontendIntegration = testingIntegrationFunctions();
    }
  });
  return null;
};
